import * as React from 'react';

type Props = {
  children: (props: {
    isActive: boolean;
    activate: () => void;
    deactivate: () => void;
    toggle: () => void;
  }) => React.ReactNode;
};

type State = {
  isActive: boolean;
};

export default class Toggle extends React.Component<Props, State> {
  state = {
    isActive: false,
  };

  render() {
    return this.props.children({
      isActive: this.state.isActive,
      activate: () => this.setState({ isActive: true }),
      deactivate: () => this.setState({ isActive: false }),
      toggle: () => this.setState((prevState) => ({ isActive: !prevState.isActive })),
    });
  }
}
